import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DotCMSContentlet } from 'dotcms/src/lib/models';

import { CustomDotCmsContentlet } from '../../../models/contentlet/custom-dotcms-contentlet.model';
import { DotCmsContentTypeComponent } from '../../../models/dot-cms-content-types-component.model';
import { isInsideEditor } from '@dotcms/client';

@Component({
  selector: 'custom-dot-cms-fallback',
  templateUrl: './dot-cms-fallback.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DotCmsFallbackComponent implements DotCmsContentTypeComponent {
  contentlet: DotCMSContentlet;
  blockEditorContent: CustomDotCmsContentlet;
  //isProductionMode: boolean = PRODUCTION_MODE;
  isEditMode = isInsideEditor();
}
